var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-stepper"},[_c('van-stepper',{attrs:{"input-width":`${_vm.inputWidth}px`,"max":_vm.max,"button-size":`${{buttonSize: _vm.buttonSize}}px`},model:{value:(_vm.isValue),callback:function ($$v) {_vm.isValue=$$v},expression:"isValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }